<template>
	<div class="cm-detail-error">
		<div class="container py-5">
			<div class="d-flex mb-2">
				<i class="mdi mdi-alert font-32 me-2"></i>
				<div class="error-head">
					<h2 class="mb-0">Fahrzeug nicht gefunden</h2>
				</div>
			</div>
			<p>Das angeforderte Fahrzeug kann nicht angezeigt werden, weil:</p>
			<ul class="list-unstyled">
				<li>...das Fahrzeug bereits verkauft wurde.</li>
				<li>...das Fahrzeug in eine andere Filiale verschoben wurde.</li>
				<li>
					...über eine Suchmaschine ein veralteter Eintrag dieses Fahrzeugs
					aufgerufen wurde.
				</li>
			</ul>
			<router-link :to="{ name: 'List' }" class="btn btn-white"
				><i class="mdi mdi-chevron-left"></i> Zurück zur Suche
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsError',
}
</script>

<style scoped></style>
